import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Data } from 'src/app/helper/datastore';
import { WebRequestService } from 'src/app/services/web-request.service';
import { LoaderComponent } from '../builders/loader/loader.component';

@Component({
  selector: 'app-call-reason',
  templateUrl: './call-reason.component.html',
  styleUrls: ['./call-reason.component.scss']
})
export class CallReasonComponent implements OnInit {

  LoaderComponent: any = '';
  pageID: any;
  callReasonArray: any;
  customerContactData: any;
  contactName: any;
  custContactID: any;
  loginData: any;
  custID: any;
  callReasonForm: FormGroup;
  personalDetails: any;
  contactRelationArray: any;
  callRelationForm: any;
  custContactIDMatchFollowUp: any;
  contactNameMatchFollowUp: any;
  custContactIDMarketing: any;
  contactNameMarketing: any;
  contactNumberMarketing:any
  countryArrayMarketing:any;
  isRelation:boolean=false;
  ticketIdMFU:any;
  contactNumber:any;
  countryArray:any;
  audioSrc:any;
  logID:any;
  countryArrayEditView:any;
  // isCallStatus: boolean = false;
  // isCallStatusMarketing
  relationId:any;
  isCallInitiated:boolean = false;
  isCallInitiatedMFU:boolean = false;
  isCallInitiatedMarketing:boolean = false;
  callResponseMessage:any;
  callResponseMessage1:any;
  makeCallAccess:any;
  profileOwner:any;
  isTypeSelected:boolean = false;
  isConferenceCall:boolean;
  profileLogID:any;
  



  constructor(public service: WebRequestService, private loginDataStore: Data, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) private modalData: any,
    public dialogRef: MatDialogRef<CallReasonComponent>
  ) { }

  ngOnInit() {

    this.callReasonForm = new FormGroup({
      callReason: new FormControl(null, [Validators.required])
    })

    this.callRelationForm = new FormGroup({
      callRelation: new FormControl(null, [Validators.required])
    })

    this.loginDataStore.getStoreData('empData')
      .then((dataRes: any) => {
        this.loginData = JSON.parse(dataRes);
        // console.log(this.loginData)
      })
      .catch((err) => console.error(err));




    this.pageID = this.modalData.PageId;
    this.custID = this.modalData.custID;
    this.relationId = this.modalData.relationId;
    this.ticketIdMFU = this.modalData.ticketID;
    this.personalDetails = this.modalData.personalDetails;
    this.customerContactData = this.modalData.customerData;
    this.contactRelationArray = this.modalData.contactRelation;
    this.logID = this.modalData.logId;
    this.audioSrc = this.modalData.audioSrc;
    this.makeCallAccess = this.modalData.makeCall[0];
    this.profileOwner = this.modalData.makeCall[1];
    this.profileLogID = this.modalData.profileLogId;

    if(this.pageID === 1){
      this.contactName = this.customerContactData[0]['RelationName'];
      this.custContactID = this.customerContactData[0]['Cust_ContactNumbers_ID'];
      this.countryArrayEditView = {CountryCode: this.customerContactData[0]['CountryCode'], CountryName: this.customerContactData[0]['CountryName']}

    }
    this.service.loadMasterData('ClickToCallReason').then((res) => {
      if (res['statusCode'] === 200) {
        this.callReasonArray = res['result'];
        // console.log(this.callReasonArray);

      }
    }).catch((err) => { console.log(err) })
  }



  initiateClickToCall() {

    const reasonObject = {
      ContactType: 614,
      custID: this.custID,
      pageName: "Edit View",
      profileOwnerID: this.personalDetails['ProfileOwnerEmpID'],
      reason: this.callReasonForm.value['callReason'].value,
      section: "Parent Details",
      viewType: "call",
      ReasonID: this.callReasonForm.value['callReason'].id
    }

    this.service.viewContactOrEmailForOtherEmp(reasonObject).then((response) => {
      if (response['statusCode'] === 200) {
        const clickToCallObj = {
          application: 'E',
          empID: this.loginData['employeeID'],
          custID: this.custID,
          pageId: 2,
          section: 'Parent Details',
          ticketId: '',
          cust_ContactNumbers_Id: this.custContactID,
          clicktoCallResponseCode: 0,
          RelationShipID: this.relationId,
          ReasonID: this.callReasonForm.value['callReason'].id
        }
        this.LoaderComponent = LoaderComponent;
        this.service.initiateClickToCall(clickToCallObj).then((res) => {
          if(res['statusCode'] === 200){
            this.LoaderComponent = '';
            // this.isCallStatus = true;
            this.isCallInitiated = true
            this.callResponseMessage = res['message']
            this.callResponseMessage1 = 'We are connecting you to the customer'
            setTimeout(()=>{
              this.dialogRef.close({data : 1});
              },5000)
              
          } else {
            this.LoaderComponent = '';
            this.isCallInitiated = true
            this.callResponseMessage = res['message'];
            this.callResponseMessage1 = 'Please try again later'
          }
        })
          .catch((err) => { console.log(err) })
      }
    })

  }


  selectCustomerRelationFollowUp() {
    const relationId = this.callRelationForm.value['callRelation'].id 
    this.service.getCustomerContactID(relationId, this.custID,1)
      .then((response) => {
        // console.log(response['result'])
        this.isRelation = true;
        this.custContactIDMatchFollowUp = response['result'][0].Cust_ContactNumbers_ID;
        this.contactNameMatchFollowUp = response['result'][0].RelationName;
        this.contactNumber = response['result'][0].ContactNumber;
        this.countryArray = {CountryCode: response['result'][0].CountryCode, CountryName: response['result'][0].CountryName};
      })
      .catch((err) => console.log(err));
  }

  selectCustomerRelationMarketing() {
    const relationId = this.callRelationForm.value['callRelation'].id
    this.service.getCustomerContactID(relationId, this.custID,1)
      .then((response) => {
        // console.log(response['result'])
        this.isRelation = true;
        this.custContactIDMarketing = response['result'][0].Cust_ContactNumbers_ID;
        this.contactNameMarketing = response['result'][0].RelationName;
        this.contactNumberMarketing = response['result'][0].ContactNumber;
        this.countryArrayMarketing = {CountryCode: response['result'][0].CountryCode, CountryName: response['result'][0].CountryName};
      })
      .catch((err) => console.log(err));
  }




  initiateClickToCallInMFU() {

    const relationId = this.callRelationForm.value['callRelation'].id

    const clickToCallObj = {
      application: 'E',
      empID: this.loginData['employeeID'],
      custID: this.custID,
      pageId: 12,
      section: 'Match Followup',
      ticketId: this.ticketIdMFU,
      cust_ContactNumbers_Id: this.custContactIDMatchFollowUp,
      clicktoCallResponseCode: 0,
      RelationShipID: relationId,
      ReasonID: null,
      IsConference: this.isConferenceCall,
      ProfileLogID: this.profileLogID
    }
    // console.log(clickToCallObj)
    this.LoaderComponent = LoaderComponent;
    this.service.initiateClickToCall(clickToCallObj).then((res) => {
      if(res['statusCode'] === 200){
        this.LoaderComponent = '';
        // this.isCallStatusMFU = true;
        this.isCallInitiatedMFU = true;
        this.callResponseMessage = res['message'];
        this.callResponseMessage1 = 'We are connecting you to the customer'
        setTimeout(()=>{
          this.dialogRef.close({data : 1});
          },5000)
          
      }else {
        this.LoaderComponent = '';
        this.isCallInitiatedMFU = true
        this.callResponseMessage = res['message'];
        this.callResponseMessage1 = 'Please try again later'
      }
    })
      .catch((err) => { console.log(err) })
  }

  initiateClickToCallInMarketing() {
    const relationId = this.callRelationForm.value['callRelation'].id
    const clickToCallObj = {
      application: 'E',
      empID: this.loginData['employeeID'],
      custID: this.custID,
      pageId: 11,
      section: 'Marketing Ticket',
      ticketId: this.ticketIdMFU,
      cust_ContactNumbers_Id: this.custContactIDMarketing,
      clicktoCallResponseCode: 0,
      RelationShipID: relationId,
      ReasonID: null

    }
    // console.log(clickToCallObj)
    this.LoaderComponent = LoaderComponent;
        this.service.initiateClickToCall(clickToCallObj).then((res) => {
          if(res['statusCode'] === 200){
            this.LoaderComponent = '';
            // this.isCallStatusMarketing = true;
            this.isCallInitiatedMarketing = true;
            this.callResponseMessage = res['message'];
            this.callResponseMessage1 = 'We are connecting you to the customer'
            setTimeout(()=>{
              this.dialogRef.close({data : 1});
              },5000)
              
          }else {
            this.LoaderComponent = '';
            this.isCallInitiatedMarketing = true
            this.callResponseMessage = res['message'];
            this.callResponseMessage1 = 'Please try again later'
          }
        })
      .catch((err) => { console.log(err) })
  }

  onNoClick() {
    this.dialogRef.close({data: 0});
  }
  typeOfCall(type: boolean){
    this.isTypeSelected = true;
    this.isConferenceCall = type;
  }

}
